import ForgetPassword from './forget-password.vue'

export default ForgetPassword
